module.exports = __webpack_public_path__ + "static/img/rank_83.02f1e85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_83.png
// module id = eEr6
// module chunks = 1